import * as React from 'react';
import { useAuth, useRequireAuth } from 'auth';
import { useHasFeature } from 'api';
import { getBaseSettings, getZDChatSettings, getZDContactSettings } from './helper';
import Zendesk, { ZendeskAPI } from 'react-zendesk';
import { FrontendConfigFeaturesEnum } from 'oas';
import { useGetMappedUserLanguage } from '../language/use-get-mapped-user-language';

export const ZenDesk: React.FunctionComponent = () => {
    const { user } = useAuth();
    const [isZDloaded, setIsZDloaded] = React.useState(false);
    const vectorCoreHelpCenter = 'a18e100a-5532-4b15-813b-225eb53241f7';
    const openFieldWebHelpCenter = '9a1e2e81-cca2-46d3-95fc-83b94c5d3688';

    const userLanguage = useGetMappedUserLanguage();
    const showVectorCoreHelpCenter = useHasFeature(FrontendConfigFeaturesEnum.ShowCoreHelpCenter);

    const auth = useRequireAuth();
    const isLoading = auth.indeterminate || !auth.isAuthenticated;

    const updateSettings = React.useCallback(
        (chatOnline: boolean) => {
            const webwidget = {
                ...getZDChatSettings(chatOnline),
                ...getZDContactSettings(!showVectorCoreHelpCenter, user?.name),
                ...getBaseSettings,
            };
            ZendeskAPI('webWidget', 'updateSettings', webwidget);
        },
        [showVectorCoreHelpCenter, user?.name],
    );

    React.useEffect(() => {
        if (user && !isLoading && showVectorCoreHelpCenter !== null && isZDloaded) {
            ZendeskAPI('webWidget', 'setLocale', userLanguage);

            if (showVectorCoreHelpCenter) {
                updateSettings(false);
            } else {
                ZendeskAPI('webWidget:on', 'chat:departmentStatus', (dept: { name: string; status: string }) => {
                    const isSupportAndOnline = dept.name === 'Catapult Support' && dept.status === 'online';
                    updateSettings(isSupportAndOnline);
                });
            }
        }
    }, [isLoading, showVectorCoreHelpCenter, isZDloaded, user, userLanguage, updateSettings]);

    return (
        <>
            {process.env.REACT_APP_ENVIRONMENT !== 'dev' && !isLoading && showVectorCoreHelpCenter !== null ? (
                <Zendesk
                    zendeskKey={showVectorCoreHelpCenter ? vectorCoreHelpCenter : openFieldWebHelpCenter}
                    {...getBaseSettings}
                    onLoaded={() => setIsZDloaded(true)}
                />
            ) : null}
        </>
    );
};
